import { Styles } from '@t2c/shared-fe';

export const profileStyle: Styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingBottom: '30px',
    // backgroundColor: (theme)=> theme.palette.background.secondary
  },
  welcomeText: { fontSize: '22px', fontWeight: '400' },
  detailsContainer: {
    border: (theme) => `1px solid ${theme.palette.background.border}`,
    borderRadius: '20px',
    padding: '1%',
  },
  sectionsWrapper: {
    display: 'flex',
  },
  profileInfoSection: {
    flex: 1,
  },

  inputsWrapper: {
    display: 'flex',
    gap: '2%',
    flexWrap: 'wrap',
    marginBottom: '2%',
  },
  inputBox: {
    width: '49%',
    minWidth: '200px',
    marginTop: '2%',
  },
  input: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      border: '1px solid',
      borderRadius: '6px',
      borderColor: (theme) => theme.palette.background.border,
      backgroundColor: (theme) => theme.palette.background.secondary,
      '&:hover': {
        borderColor: (theme) => theme.palette.background.activeBorder,
      },
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: (theme) => theme.palette.text.lighterText2,
    },
  },
  disabledInput: {
    width: '100%',
    // backgroundColor: 'background.disabledInput',
    '& .MuiOutlinedInput-root': {
      border: '1px solid',
      borderRadius: '6px',
      borderColor: (theme) => theme.palette.background.border,
      backgroundColor: (theme) => theme.palette.background.primary,
      '&:hover': {
        borderColor: (theme) => theme.palette.background.activeBorder,
      },
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: (theme) => theme.palette.text.lighterText2,
    },
  },
  profileImg: {
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    overflow: 'hidden',
  },
  welcomeBox: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'center',
  },
  chip: {
    padding: '1px',
    borderRadius: 100,
    display: 'inline-block',
    background: (theme) => theme.palette.gradients.gradient4,
    backgroundClip: 'border-box',
    border: '1px solid transparent',
    minWidth: '110px',
    '& > div': {
      backgroundColor: (theme) => theme.palette.background.secondary,
      borderRadius: 'inherit',
      padding: '4px 12px',
      textAlign: 'center',
    },
  },
  emailAddresses: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  flexEnd: {
    display: 'flex',
    gap: 1,
    justifyContent: 'end',
  },
  deleteBtn: {
    color: 'text.secondary',
    borderBottomWidth: '1px',
    borderColor: 'text.secondary',
  },
  mailIcon: {
    height: '48px',
    width: '48px',
    borderRadius: '24px',
    backgroundColor: '#ECF3FF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mailIdAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  btns: {
    display: 'flex',
    gap: 1,
    mb: '16px',
  },
  creditsAndUpgradeBox: {
    width: '100%',
    height: '180px',
    background: (theme) => theme.palette.gradients.cardGradient2,
    bottom: 2,
    borderRadius: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    pr: { xs: 2, md: 4 },
    pl: { xs: 2, md: 8 },
    position: 'relative',
    overflow: 'hidden',
  },
  editBtn: {
    color: (theme) => theme.palette.text.primary,
    boxShadow: 'none',
    borderRadius: '48px',
    minWidth: '48px',
    minHeight: '48px',
    padding: 0,
  },
  Btn: {
    color: (theme) => theme.palette.text.primary,
    boxShadow: 'none',
  },
  tableTitle: {
    color: '#fff',
    fontWeight: 'bold',
    mt: 4,
    mb: 1,
  },
};
